import React, { useEffect, useMemo, useRef, useState } from "react";
import ExceptionVariables from "../JSON Files/ExceptionVariables.json";
import { useDispatch } from "react-redux";
import getNotification from "../../Redux/Action/action";
import Select from "react-select";

function UbLbTable({
  objective,
  originalsetublboriginal,
  sampledataset2,
  originalset2,
  handleoriginaldataset2change,
  handlesampledataset2change,
  onOptimize,
  isprocessing,
}) {
  const hidingvariablelist = ExceptionVariables?.hiddenvariables || [];
  const [addminuspercentagelb, setaddminuspercentagelb] = useState([]);
  const [addminuspercentageub, setaddminuspercentageub] = useState([]);
  const [edit, setedit] = useState([]);
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [graphOpen, setGraphOpen] = useState(false);
  const [isCardOpen, setIsCardOpen] = useState(true);
  const [viewMode, setViewMode] = useState("graph");
  const stageRef = useRef(null);
  const stageRefs = useRef({});
  const scaleMapRef = useRef({});
  const dragTypeRef = useRef(null);
  const dragScaleRef = useRef({
    lb: { min: 0, max: 1 },
    ub: { min: 0, max: 1 },
    index: -1,
  });
  const dispatch = useDispatch();

  const isMaintainObjective =
    objective === "Maintain Spends to Maximize Sales" ||
    objective === "Maintain Sales and Minimize Spends";

  const getUpperValue = (item) =>
    isMaintainObjective ? Number(item?.c_point) || 0 : Number(item?.d_point) || 0;

  const visibleDataset = useMemo(() => {
    return (sampledataset2 || []).filter(
      (item) => !hidingvariablelist.some((variable) => variable === item.variables)
    );
  }, [sampledataset2, hidingvariablelist]);

  const attributeOptions = useMemo(() => {
    return visibleDataset.map((item) => ({
      label: item.variables,
      value: item.variables,
    }));
  }, [visibleDataset]);

  const filteredDataset = useMemo(() => {
    if (!selectedAttributes?.length) return visibleDataset;
    const selectedValues = selectedAttributes.map((item) => item.value);
    return visibleDataset.filter((item) => selectedValues.includes(item.variables));
  }, [visibleDataset, selectedAttributes]);

  useEffect(() => {
    if (!attributeOptions.length) {
      setSelectedChannel(null);
      return;
    }
    const stillValid = attributeOptions.some(
      (opt) => opt.value === selectedChannel?.value
    );
    if (!stillValid) {
      setSelectedChannel(attributeOptions[0]);
    }
  }, [attributeOptions, selectedChannel]);

  const selectedIndex = useMemo(() => {
    if (!selectedChannel) return -1;
    return (sampledataset2 || []).findIndex(
      (row) => row.variables === selectedChannel.value
    );
  }, [sampledataset2, selectedChannel]);

  const selectedItem =
    selectedIndex >= 0 ? sampledataset2[selectedIndex] : null;

  const table2edit = (e, variableIndex, type) => {
    const updatedDataset = [...sampledataset2];
    const enteredvalue = e.target.value || 0;

    if (type === "lb") {
      let arr = [...addminuspercentagelb];
      const percentageChange = (
        ((enteredvalue - originalsetublboriginal[variableIndex].a_point) /
          originalsetublboriginal[variableIndex].a_point) *
        100
      )?.toFixed(2);
      arr[variableIndex] = percentageChange === "Infinity" ? 0 : percentageChange;
      updatedDataset[variableIndex].a_point = enteredvalue;
      setaddminuspercentagelb(arr);
    } else if (type === "ub") {
      let arr = [...addminuspercentageub];
      if (
        objective === "Maintain Spends to Maximize Sales" ||
        objective === "Maintain Sales and Minimize Spends"
      ) {
        const percentageChange = (
          ((enteredvalue - originalsetublboriginal[variableIndex].c_point) /
            originalsetublboriginal[variableIndex].c_point) *
          100
        )?.toFixed(2);
        arr[variableIndex] = percentageChange === "Infinity" ? 0 : percentageChange;
        updatedDataset[variableIndex].c_point = enteredvalue;
      } else {
        const percentageChange = (
          ((enteredvalue - originalsetublboriginal[variableIndex].d_point) /
            originalsetublboriginal[variableIndex].d_point) *
          100
        )?.toFixed(2);
        arr[variableIndex] = percentageChange === "Infinity" ? 0 : percentageChange;
        updatedDataset[variableIndex].d_point = enteredvalue;
      }
      setaddminuspercentageub(arr);
    }

    handlesampledataset2change(updatedDataset);
  };

  const table2editpercetnagebasis = (e, variableIndex, type) => {
    const updatedDataset = [...sampledataset2];
    const enteredValue = parseFloat(e.target.value) || 0;

    if (type === "lb") {
      const arr = [...addminuspercentagelb];
      arr[variableIndex] = e.target.value;
      setaddminuspercentagelb(arr);
      updatedDataset[variableIndex].a_point = Number(
        originalsetublboriginal[variableIndex].a_point * (1 + enteredValue / 100)
      )?.toFixed(2);
    } else if (type === "ub") {
      const arr = [...addminuspercentageub];
      arr[variableIndex] = e.target.value;
      setaddminuspercentageub(arr);
      if (isMaintainObjective) {
        updatedDataset[variableIndex].c_point = Number(
          originalsetublboriginal[variableIndex].c_point * (1 + enteredValue / 100)
        )?.toFixed(2);
      } else {
        updatedDataset[variableIndex].d_point = Number(
          originalsetublboriginal[variableIndex].d_point * (1 + enteredValue / 100)
        )?.toFixed(2);
      }
    }

    handlesampledataset2change(updatedDataset);
  };

  const handlecancel = (variableIndex) => {
    const updatedDataset1 = [...sampledataset2];
    const updatedDataset2 = [...originalset2];

    let arr1 = [...addminuspercentagelb];
    let arr2 = [...addminuspercentageub];

    const isMaintainObjectiveLocal =
      objective === "Maintain Spends to Maximize Sales" ||
      objective === "Maintain Sales and Minimize Spends";

    const lowerLimitBase = originalsetublboriginal[variableIndex].a_point || 1;
    const upperKey = isMaintainObjectiveLocal ? "c_point" : "d_point";

    const upperLimitBase = originalsetublboriginal[variableIndex][upperKey] || 1;

    let percentageChangelb =
      ((updatedDataset1[variableIndex].lower_limit -
        originalsetublboriginal[variableIndex].lower_limit) /
        lowerLimitBase) *
      100;

    let percentageChangeub =
      ((updatedDataset1[variableIndex][upperKey] -
        originalsetublboriginal[variableIndex][upperKey]) /
        upperLimitBase) *
      100;

    percentageChangelb = isFinite(percentageChangelb)
      ? percentageChangelb.toFixed(0)
      : 0;
    percentageChangeub = isFinite(percentageChangeub)
      ? percentageChangeub.toFixed(0)
      : 0;

    setaddminuspercentagelb(arr1);
    setaddminuspercentageub(arr2);

    if (isMaintainObjectiveLocal) {
      updatedDataset1[variableIndex].c_point = updatedDataset2[variableIndex].c_point;
    } else {
      updatedDataset1[variableIndex].d_point = updatedDataset2[variableIndex].d_point;
    }

    updatedDataset1[variableIndex].a_point = updatedDataset2[variableIndex].a_point;
    handlesampledataset2change(updatedDataset1);
  };

  const resetToOriginal = (variableIndex) => {
    const source = originalsetublboriginal?.[variableIndex];
    if (!source) return;
    const restoreRow = (dataset) =>
      (dataset || []).map((row, idx) =>
        idx === variableIndex
          ? { ...row, a_point: source.a_point, c_point: source.c_point, d_point: source.d_point }
          : row
      );
    handlesampledataset2change(restoreRow(sampledataset2));
    handleoriginaldataset2change(restoreRow(originalset2));

    const lbArr = [...addminuspercentagelb];
    const ubArr = [...addminuspercentageub];
    lbArr[variableIndex] = "";
    ubArr[variableIndex] = "";
    setaddminuspercentagelb(lbArr);
    setaddminuspercentageub(ubArr);
    setedit([]);
  };

  const handleupdate = (variableIndex) => {
    const updatedDataset1 = [...sampledataset2];
    const updatedDataset2 = [...originalset2];
    let arr1 = [...addminuspercentagelb];
    let arr2 = [...addminuspercentageub];

    const isMaintainObjectiveLocal =
      objective === "Maintain Spends to Maximize Sales" ||
      objective === "Maintain Sales and Minimize Spends";

    const lowerLimitBase = originalsetublboriginal[variableIndex].a_point || 1;
    const upperKey = isMaintainObjectiveLocal ? "c_point" : "d_point";
    const upperLimitBase = originalsetublboriginal[variableIndex][upperKey] || 1;

    let percentageChangelb =
      ((Number(updatedDataset1[variableIndex].a_point) -
        Number(originalsetublboriginal[variableIndex].a_point)) /
        lowerLimitBase) *
      100;

    let percentageChangeub =
      ((Number(updatedDataset1[variableIndex][upperKey]) -
        Number(originalsetublboriginal[variableIndex][upperKey])) /
        upperLimitBase) *
      100;

    percentageChangelb = isFinite(percentageChangelb)
      ? percentageChangelb.toFixed(0)
      : 0;
    percentageChangeub = isFinite(percentageChangeub)
      ? percentageChangeub.toFixed(0)
      : 0;

    if (
      percentageChangelb <= 25 &&
      percentageChangelb >= -25 &&
      percentageChangeub <= 25 &&
      percentageChangeub >= -25
    ) {
      const lowerBound = updatedDataset1[variableIndex].a_point;
      const comparePoint = isMaintainObjectiveLocal
        ? updatedDataset1[variableIndex].c_point
        : updatedDataset1[variableIndex].d_point;

      if (Number(lowerBound) > Number(comparePoint)) {
        dispatch(
          getNotification({
            message: `Upper Bound is less than lower bound!`,
            type: "danger",
          })
        );
      } else {
        arr1[variableIndex] = percentageChangelb;
        arr2[variableIndex] = percentageChangeub;
        setaddminuspercentagelb(arr1);
        setaddminuspercentageub(arr2);

        if (isMaintainObjectiveLocal) {
          updatedDataset2[variableIndex].c_point =
            updatedDataset1[variableIndex].c_point;
        } else {
          updatedDataset2[variableIndex].d_point =
            updatedDataset1[variableIndex].d_point;
        }

        updatedDataset2[variableIndex].a_point =
          updatedDataset1[variableIndex].a_point;

        edit[variableIndex] = false;
        handleoriginaldataset2change(updatedDataset2);

        dispatch(
          getNotification({
            message: `Bounds updated for ${updatedDataset2[variableIndex].variables}`,
            type: "success",
          })
        );
      }
    } else if (
      percentageChangelb > 25 ||
      percentageChangelb < -25 ||
      percentageChangeub > 25 ||
      percentageChangeub < -25
    ) {
      let confirmedbounds = window.confirm(
        "Entered change percentage is not within -25% to 25% range.Do you wish to continue?"
      );

      if (confirmedbounds) {
        const lowerBound = updatedDataset1[variableIndex].a_point;
        const comparePoint = isMaintainObjectiveLocal
          ? updatedDataset1[variableIndex].c_point
          : updatedDataset1[variableIndex].d_point;

        if (Number(lowerBound) > Number(comparePoint)) {
          dispatch(
            getNotification({
              message: `Upper Bound is less than lower bound!`,
              type: "danger",
            })
          );
          return;
        }

        arr1[variableIndex] = percentageChangelb;
        arr2[variableIndex] = percentageChangeub;
        setaddminuspercentagelb(arr1);
        setaddminuspercentageub(arr2);

        if (isMaintainObjectiveLocal) {
          updatedDataset2[variableIndex].c_point =
            updatedDataset1[variableIndex].c_point;
        } else {
          updatedDataset2[variableIndex].d_point =
            updatedDataset1[variableIndex].d_point;
        }

        updatedDataset2[variableIndex].a_point =
          updatedDataset1[variableIndex].a_point;

        edit[variableIndex] = false;
        handleoriginaldataset2change(updatedDataset2);

        dispatch(
          getNotification({
            message: `Bounds updated for ${updatedDataset2[variableIndex].variables}`,
            type: "success",
          })
        );
      }
    }
  };

  const beginEdit = (variableIndex) => {
    const arr = [];
    arr[variableIndex] = true;
    setedit(arr);
  };

  const openGraphPopup = (variableIndex) => {
    const row = sampledataset2?.[variableIndex];
    if (!row) return;
    setSelectedChannel({ label: row.variables, value: row.variables });
    beginEdit(variableIndex);
    setGraphOpen(true);
  };

  const clampToOtherBound = (variableIndex, type, value) => {
    const row = sampledataset2?.[variableIndex];
    const num = Number(value);
    if (!row || !isFinite(num)) return value;
    if (type === "lb") {
      const ub = getUpperValue(row);
      return num > ub ? ub : value;
    }
    const lb = Number(row.a_point) || 0;
    return num < lb ? lb : value;
  };

  const isBoundCrossed = (row) =>
    !!row && Number(row.a_point) > getUpperValue(row);

  const applyBoundDrag = (variableIndex, type, value) => {
    beginEdit(variableIndex);
    const safeValue = clampToOtherBound(variableIndex, type, value);
    table2edit({ target: { value: safeValue } }, variableIndex, type);
  };

  const commitBoundDrag = (variableIndex) => {
    handleupdate(variableIndex);
    setedit([]);
  };

  const formatBound = (val) => {
    const num = Number(val);
    if (!isFinite(num)) return "0.00";
    return num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const curveY = (pct) => 78 - 58 / (1 + Math.exp(-10 * (pct / 100 - 0.55)));

  const valueFromClientX = (clientX, type) => {
    const el = stageRef.current;
    const scale = dragScaleRef.current?.[type] || { min: 0, max: 1 };
    const { min, max } = scale;
    if (!el) return min;
    const rect = el.getBoundingClientRect();
    const pct = Math.min(100, Math.max(0, ((clientX - rect.left) / (rect.width || 1)) * 100));
    const raw = min + (pct / 100) * (max - min || 1);
    const step = max > 1000 ? 1 : max > 10 ? 0.1 : 0.01;
    return Number((Math.round(raw / step) * step).toFixed(2));
  };

  const onStagePointerMove = (e) => {
    if (!dragTypeRef.current) return;
    const { index } = dragScaleRef.current;
    if (index < 0) return;
    const value = valueFromClientX(e.clientX, dragTypeRef.current);
    applyBoundDrag(index, dragTypeRef.current, value);
  };

  const onStagePointerUp = () => {
    dragTypeRef.current = null;
  };

  const startPointDrag = (type, e, variableIndex) => {
    e.preventDefault();
    e.stopPropagation();
    dragTypeRef.current = type;
    stageRef.current = stageRefs.current[variableIndex] || null;
    dragScaleRef.current = {
      ...(scaleMapRef.current[variableIndex] || { lb: { min: 0, max: 1 }, ub: { min: 0, max: 1 } }),
      index: variableIndex,
    };
    if (stageRef.current?.setPointerCapture) {
      stageRef.current.setPointerCapture(e.pointerId);
    }
    if (variableIndex >= 0) {
      const value = valueFromClientX(e.clientX, type);
      applyBoundDrag(variableIndex, type, value);
    }
  };

  const renderBoundsGraph = (variableIndex) => {
    const row = variableIndex >= 0 ? sampledataset2?.[variableIndex] : null;
    if (!row) {
      return <div className="ublb-graph-empty">No channel available to edit bounds.</div>;
    }

    const lb = Number(row.a_point) || 0;
    const ub = getUpperValue(row);
    const origLb = Math.abs(Number(originalsetublboriginal?.[variableIndex]?.a_point) || 0);
    const origUb = Math.abs(
      Number(
        isMaintainObjective
          ? originalsetublboriginal?.[variableIndex]?.c_point
          : originalsetublboriginal?.[variableIndex]?.d_point
      ) || 0
    );

    // LB and UB share one axis (0 → 2× the larger original) so pin order on screen matches LB ≤ UB.
    const origin = Math.max(origLb, origUb) || Math.max(lb, ub) || 1;
    const sharedScale = { min: 0, max: origin * 2 };
    scaleMapRef.current[variableIndex] = { lb: sharedScale, ub: sharedScale };

    const toPct = (v) =>
      Math.min(
        100,
        Math.max(0, ((Number(v) - sharedScale.min) / (sharedScale.max - sharedScale.min || 1)) * 100)
      );

    const referenceLines = (orig) =>
      orig > 0 ? [toPct(orig * 0.75), toPct(orig), toPct(orig * 1.25)] : [];
    const lbRefs = referenceLines(origLb);
    const ubRefs = referenceLines(origUb);

    const lbPct = toPct(lb);
    const ubPct = toPct(ub);
    const bandLeft = Math.min(lbPct, ubPct);
    const bandWidth = Math.abs(ubPct - lbPct);
    const lbY = curveY(lbPct);
    const ubY = curveY(ubPct);

    const curvePoints = Array.from({ length: 41 }, (_, i) => {
      const t = i / 40;
      const x = t * 100;
      const y = curveY(x);
      return `${x},${y}`;
    }).join(" ");

    const fillId = `ublbFill-${variableIndex}`;

    return (
      <div className="ublb-graph-panel">
        <div
          className="ublb-graph-stage"
          ref={(el) => {
            stageRefs.current[variableIndex] = el;
          }}
          onPointerMove={onStagePointerMove}
          onPointerUp={onStagePointerUp}
          onPointerLeave={onStagePointerUp}
        >
          <div className="ublb-graph-plot">
          <svg viewBox="0 0 100 90" className="ublb-graph-svg" preserveAspectRatio="none">
            <defs>
              <linearGradient id={fillId} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="rgba(13,124,102,0.22)" />
                <stop offset="100%" stopColor="rgba(13,124,102,0.02)" />
              </linearGradient>
            </defs>
            <rect
              x={bandLeft}
              y="8"
              width={Math.max(bandWidth, 0.5)}
              height="70"
              fill="rgba(13,124,102,0.08)"
            />
            <polyline
              points={`0,78 ${curvePoints} 100,78`}
              fill={`url(#${fillId})`}
              stroke="none"
            />
            <polyline
              points={curvePoints}
              fill="none"
              stroke="#0d7c66"
              strokeWidth="2.2"
              vectorEffect="non-scaling-stroke"
            />
            <line x1="0" y1="78" x2="100" y2="78" stroke="currentColor" strokeWidth="0.5" opacity="0.28" />
            {lbRefs.map((x, i) => (
              <line
                key={`lb-ref-${i}`}
                x1={x}
                y1="8"
                x2={x}
                y2="78"
                stroke="#0d7c66"
                strokeWidth={i === 1 ? "0.5" : "0.35"}
                opacity={i === 1 ? "0.5" : "0.3"}
              />
            ))}
            {ubRefs.map((x, i) => (
              <line
                key={`ub-ref-${i}`}
                x1={x}
                y1="8"
                x2={x}
                y2="78"
                stroke="#17a2b8"
                strokeWidth={i === 1 ? "0.5" : "0.35"}
                opacity={i === 1 ? "0.5" : "0.3"}
              />
            ))}
            <line
              x1={lbPct}
              y1={lbY}
              x2={lbPct}
              y2="78"
              stroke="#0d7c66"
              strokeDasharray="1.4 1.6"
              strokeWidth="0.55"
              opacity="0.55"
            />
            <line
              x1={ubPct}
              y1={ubY}
              x2={ubPct}
              y2="78"
              stroke="#17a2b8"
              strokeDasharray="1.4 1.6"
              strokeWidth="0.55"
              opacity="0.55"
            />
          </svg>

          <button
            type="button"
            className="ublb-pin is-lb"
            style={{ left: `${lbPct}%`, top: `${(lbY / 90) * 100}%` }}
            onPointerDown={(e) => startPointDrag("lb", e, variableIndex)}
          >
            <span className="ublb-pin-label">Lower · {formatBound(lb)}</span>
            <span className="ublb-pin-dot" />
          </button>
          <button
            type="button"
            className="ublb-pin is-ub"
            style={{ left: `${ubPct}%`, top: `${(ubY / 90) * 100}%` }}
            onPointerDown={(e) => startPointDrag("ub", e, variableIndex)}
          >
            <span className="ublb-pin-label">Upper · {formatBound(ub)}</span>
            <span className="ublb-pin-dot" />
          </button>
          </div>

          <div className="ublb-graph-axis">
            <span>0</span>
            <span>Lines mark original and ±25% · green = LB, blue = UB</span>
            <span>{formatBound(sharedScale.max)}</span>
          </div>
        </div>
      </div>
    );
  };

  const sliderScale25 = (base) => {
    const origin = Math.abs(Number(base)) || 0;
    if (!origin) return { min: 0, max: 1, step: 0.01 };
    const step = origin > 1000 ? 1 : origin >= 10 ? 0.1 : origin >= 1 ? 0.01 : 0.001;
    // min/max must be multiples of step, otherwise the browser snaps the thumb off the real value.
    const snap = (v) => Number((Math.round(v / step) * step).toFixed(3));
    return {
      min: snap(origin * 0.75),
      max: snap(origin * 1.25),
      step,
    };
  };

  const renderBoundEditor = (variableIndex, type, value, base) => {
    const scale = sliderScale25(base);
    const percentValue =
      type === "lb"
        ? addminuspercentagelb[variableIndex] ?? ""
        : addminuspercentageub[variableIndex] ?? "";
    const crossed = isBoundCrossed(sampledataset2?.[variableIndex]);
    return (
      <div className="ublb-edit-stack">
        <div className="ublb-edit-fields">
          <input
            className={`rr-input ublb-step-input${crossed ? " is-invalid" : ""}`}
            type="number"
            min={scale.min}
            max={scale.max}
            step={scale.step}
            value={value}
            onChange={(e) => table2edit(e, variableIndex, type)}
          />
          <input
            className="rr-input ublb-percent-input"
            type="number"
            placeholder="% +/−"
            value={percentValue}
            onChange={(e) => table2editpercetnagebasis(e, variableIndex, type)}
          />
        </div>
        {crossed && (
          <span className="ublb-bound-warning">
            {type === "lb" ? "Lower bound cannot be more than upper bound" : "Upper bound cannot be less than lower bound"}
          </span>
        )}
      </div>
    );
  };

  const renderFilterPanel = () => (
    <div className="ublb-inner-panel ublb-filter-panel">
      <div className="row g-2 align-items-end">
        <div className="col-lg-8 col-md-12 col-12">
          <Select
            isMulti
            options={attributeOptions}
            value={selectedAttributes}
            onChange={(value) => setSelectedAttributes(value || [])}
            placeholder="Select one or multiple attributes"
            classNamePrefix="rr-select"
          />
        </div>

        <div className="col-lg-4 col-md-12 col-12">
          <button
            className="rr-btn rr-btn-secondary w-100"
            onClick={() => setSelectedAttributes([])}
          >
            Clear Filter
          </button>
        </div>
      </div>
    </div>
  );

  const renderBoundsTable = () => (
    <>
      {renderFilterPanel()}

      <div className="ublb-inner-panel ublb-table-panel">
        <div className="table-responsive rr-table-wrap">
          <table className="table rr-table ublb-compact-table align-middle mb-0">
            <thead>
              <tr>
                <th>Attribute</th>
                <th>Lower Bound (Weekly)</th>
                <th>Upper Bound (Weekly)</th>
                <th className="ublb-edit-col">Edit</th>
              </tr>
            </thead>

            <tbody>
              {filteredDataset?.length > 0 ? (
                filteredDataset.map((item) => {
                  const variableIndex = sampledataset2.findIndex(
                    (row) => row.variables === item.variables
                  );

                  if (variableIndex === -1) return null;

                  return (
                    <tr key={`row-${variableIndex}`}>
                      <td>
                        <div className="ublb-attribute-cell">
                          <span className="ublb-attribute-name">
                            {item.variables}
                          </span>
                          <span className="ublb-attribute-type">
                            {item.type}
                          </span>
                        </div>
                      </td>

                      <td>
                        <div className="ublb-bound-box">
                          {edit[variableIndex] ? (
                            renderBoundEditor(
                              variableIndex,
                              "lb",
                              item.a_point,
                              originalsetublboriginal?.[variableIndex]?.a_point
                            )
                          ) : (
                            <span className="ublb-bound-value">
                              {Number(item.a_point)?.toFixed(2)}
                            </span>
                          )}
                        </div>
                      </td>

                      <td>
                        <div className="ublb-bound-box">
                          {edit[variableIndex] ? (
                            renderBoundEditor(
                              variableIndex,
                              "ub",
                              isMaintainObjective ? item.c_point : item.d_point,
                              isMaintainObjective
                                ? originalsetublboriginal?.[variableIndex]?.c_point
                                : originalsetublboriginal?.[variableIndex]?.d_point
                            )
                          ) : (
                            <span className="ublb-bound-value">
                              {Number(getUpperValue(item))?.toFixed(2)}
                            </span>
                          )}
                        </div>
                      </td>

                      <td className="ublb-edit-col">
                        {edit[variableIndex] ? (
                          <div className="ublb-action-row">
                            <button
                              type="button"
                              className="rr-btn rr-btn-secondary rr-btn-icon"
                              title="Apply"
                              onClick={() => {
                                handleupdate(variableIndex);
                              }}
                            >
                              <i className="fa fa-check"></i>
                            </button>
                            <button
                              type="button"
                              className="rr-btn rr-btn-secondary rr-btn-icon"
                              title="Cancel"
                              onClick={() => {
                                let arr = [];
                                setedit(arr);
                                handlecancel(variableIndex);
                              }}
                            >
                              <i className="fa fa-arrow-circle-left"></i>
                            </button>
                          </div>
                        ) : (
                          <button
                            type="button"
                            className="rr-btn rr-btn-primary"
                            title="Edit"
                            onClick={() => {
                              let arr = [];
                              arr[variableIndex] = true;
                              setedit(arr);
                            }}
                          >
                            <i className="fas fa-edit me-1"></i> Edit
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4">
                    <div className="rr-empty-panel">
                      No attributes available for the selected filter.
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );

  const BOUND_SLIDER_HEADROOM = 1.5;

  const pairSliderScale = (variableIndex) => {
    const orig = originalsetublboriginal?.[variableIndex];
    const origLb = Math.abs(Number(orig?.a_point) || 0);
    const origUb = Math.abs(Number(isMaintainObjective ? orig?.c_point : orig?.d_point) || 0);
    const peak = Math.max(origLb, origUb);
    if (!peak) return { min: 0, max: 1, step: 0.01 };
    const rawMax = peak * BOUND_SLIDER_HEADROOM;
    const step = rawMax > 1000 ? 1 : rawMax >= 10 ? 0.1 : rawMax >= 1 ? 0.01 : 0.001;
    return { min: 0, max: Number((Math.round(rawMax / step) * step).toFixed(3)), step };
  };

  const getChangeVsOriginal = (variableIndex, type, value) => {
    const orig = originalsetublboriginal?.[variableIndex];
    const base = Number(
      type === "lb" ? orig?.a_point : isMaintainObjective ? orig?.c_point : orig?.d_point
    ) || 0;
    const delta = (Number(value) || 0) - base;
    if (Math.abs(delta) < 1e-9) return null;
    if (!base) return { label: "new", outOfRange: true };
    const change = (delta / Math.abs(base)) * 100;
    return {
      label: `${change > 0 ? "+" : ""}${change.toFixed(1)}%`,
      outOfRange: Math.abs(change) > 25,
    };
  };

  const renderMiniSlider = (variableIndex, type, value) => {
    const scale = pairSliderScale(variableIndex);
    const numeric = Number(value) || 0;
    const clamped = Math.min(Math.max(numeric, scale.min), scale.max);
    const pct = ((clamped - scale.min) / (scale.max - scale.min || 1)) * 100;
    const change = getChangeVsOriginal(variableIndex, type, numeric);
    return (
      <div className={`ublb-mini-bound is-${type}`}>
        <span className="ublb-mini-label">{type === "lb" ? "LB" : "UB"}</span>
        <input
          type="range"
          className={`ublb-drag-slider ${type === "lb" ? "is-lb" : "is-ub"}`}
          min={scale.min}
          max={scale.max}
          step={scale.step}
          value={clamped}
          style={{ "--ublb-fill": `${pct}%` }}
          onChange={(e) => applyBoundDrag(variableIndex, type, e.target.value)}
        />
        <span className="ublb-mini-value">{formatBound(numeric)}</span>
        <span
          className={`ublb-mini-change${change?.outOfRange ? " is-warn" : ""}`}
          title={change ? "Change vs original" : undefined}
        >
          {change?.label || ""}
        </span>
      </div>
    );
  };

  const renderGraphView = () => (
    <>
      {renderFilterPanel()}

      <div className="ublb-inner-panel ublb-table-panel">
        <div className="table-responsive rr-table-wrap">
          <table className="table rr-table ublb-compact-table ublb-graph-table align-middle mb-0">
            <thead>
              <tr>
                <th>Attribute</th>
                <th>Lower / Upper Bound (Weekly)</th>
                <th className="ublb-edit-col">Graph</th>
              </tr>
            </thead>

            <tbody>
              {filteredDataset?.length > 0 ? (
                filteredDataset.map((item) => {
                  const variableIndex = sampledataset2.findIndex(
                    (row) => row.variables === item.variables
                  );

                  if (variableIndex === -1) return null;

                  const crossed = isBoundCrossed(item);
                  const isRowEditing = !!edit[variableIndex];
                  const hasChanges =
                    isRowEditing ||
                    !!getChangeVsOriginal(variableIndex, "lb", item.a_point) ||
                    !!getChangeVsOriginal(variableIndex, "ub", getUpperValue(item));

                  return (
                    <tr key={`graph-row-${variableIndex}`}>
                      <td>
                        <div className="ublb-attribute-cell">
                          <span className="ublb-attribute-name">
                            {item.variables}
                          </span>
                          <span className="ublb-attribute-type">
                            {item.type}
                          </span>
                        </div>
                      </td>

                      <td>
                        <div className="ublb-graph-bounds">
                          {renderMiniSlider(variableIndex, "lb", item.a_point)}
                          {renderMiniSlider(variableIndex, "ub", getUpperValue(item))}
                          {crossed && (
                            <span className="ublb-bound-warning">
                              Lower bound cannot be more than upper bound
                            </span>
                          )}
                        </div>
                      </td>

                      <td className="ublb-edit-col">
                        <div className="ublb-action-row">
                          {isRowEditing && (
                            <button
                              type="button"
                              className="ublb-mini-btn is-apply"
                              title="Apply"
                              onClick={() => commitBoundDrag(variableIndex)}
                            >
                              <i className="fa fa-check"></i>
                            </button>
                          )}
                          {hasChanges && (
                            <button
                              type="button"
                              className="ublb-mini-btn"
                              title="Reset to original"
                              onClick={() => resetToOriginal(variableIndex)}
                            >
                              <i className="fa fa-undo"></i>
                            </button>
                          )}
                          <button
                            type="button"
                            className="rr-btn rr-btn-primary"
                            title="View graph"
                            onClick={() => openGraphPopup(variableIndex)}
                          >
                            <iconify-icon icon="mdi:chart-bell-curve-cumulative" class="me-1"></iconify-icon>
                            View
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="3">
                    <div className="rr-empty-panel">
                      No attributes available for the selected filter.
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className="ublb-page mt-3">
        <div className={`ublb-shell ${isCardOpen ? "is-open" : "is-collapsed"}`}>
          <div className="ublb-toolbar">
            <div className="ublb-toolbar-title">Optimization Bound</div>
            <div className="ublb-toolbar-controls">
              {isCardOpen && (
                <div className="ublb-view-toggle" role="tablist" aria-label="Bounds view">
                  <button
                    type="button"
                    role="tab"
                    aria-selected={viewMode === "graph"}
                    className={`ublb-view-btn${viewMode === "graph" ? " is-active" : ""}`}
                    onClick={() => {
                      setGraphOpen(false);
                      setViewMode("graph");
                    }}
                  >
                    <iconify-icon icon="mdi:chart-bell-curve-cumulative"></iconify-icon>
                    Graph
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={viewMode === "table"}
                    className={`ublb-view-btn${viewMode === "table" ? " is-active" : ""}`}
                    onClick={() => setViewMode("table")}
                  >
                    <iconify-icon icon="mdi:table"></iconify-icon>
                    Table
                  </button>
                </div>
              )}
              <button
                type="button"
                className="ublb-card-toggle"
                title={isCardOpen ? "Close" : "Open"}
                aria-expanded={isCardOpen}
                onClick={() => setIsCardOpen((prev) => !prev)}
              >
                {isCardOpen ? (
                  <>
                    <span>Close</span>
                    <iconify-icon icon="mdi:chevron-up"></iconify-icon>
                  </>
                ) : (
                  <>
                    <span>Open</span>
                    <iconify-icon icon="mdi:chevron-down"></iconify-icon>
                  </>
                )}
              </button>
            </div>
          </div>

          {isCardOpen && (
            <div className="ublb-shell-body">
              <div className="ublb-body-content">
                {viewMode === "graph" ? renderGraphView() : renderBoundsTable()}
              </div>

              {onOptimize && (
                <div className="ublb-body-footer">
                  <span
                    className="rr-btn rr-btn-primary"
                    style={{
                      cursor: isprocessing ? "not-allowed" : "pointer",
                      opacity: isprocessing ? 0.6 : 1,
                    }}
                    onClick={() => {
                      if (!isprocessing) onOptimize();
                    }}
                  >
                    Optimize <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {graphOpen && (
        <div className="ublb-graph-modal" role="dialog" aria-modal="true" aria-label="Optimization bound graph">
          <button
            type="button"
            className="ublb-graph-modal-backdrop"
            aria-label="Close graph"
            onClick={() => setGraphOpen(false)}
          />
          <div className="ublb-graph-modal-card">
            <div className="ublb-graph-modal-head">
              <div>
                <div className="ublb-toolbar-title">Optimization Bound</div>
                <div className="ublb-graph-modal-name">{selectedItem?.variables || "Attribute"}</div>
              </div>
              <div className="ublb-toolbar-controls">
                {selectedItem && (
                  <>
                    <span className="ublb-pill is-lb">
                      LB {formatBound(Number(selectedItem.a_point) || 0)}
                    </span>
                    <span className="ublb-pill is-ub">
                      UB {formatBound(getUpperValue(selectedItem))}
                    </span>
                  </>
                )}
                <button
                  type="button"
                  className="ublb-card-toggle"
                  onClick={() => setGraphOpen(false)}
                >
                  Close
                </button>
              </div>
            </div>
            {renderBoundsGraph(selectedIndex)}
            {selectedIndex >= 0 && (
              <div className="ublb-graph-modal-actions">
                <button
                  type="button"
                  className="ublb-bar-btn"
                  onClick={() => resetToOriginal(selectedIndex)}
                >
                  Reset
                </button>
                <button
                  type="button"
                  className="ublb-bar-btn is-primary"
                  onClick={() => {
                    commitBoundDrag(selectedIndex);
                    setGraphOpen(false);
                  }}
                >
                  Apply
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default UbLbTable;
